module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"users":{"show":{"types":{"advisor":"Advisor","expert":"Expert","institutional_investor":"Institutional investor","private":"Private investor","product_provider":"Product provider","professional":"Professional investor","professional_investor":"Professional investor"}}}}}}}')
  delete Component.options._Ctor
}
